import { BaseService } from "../baseService";
import { FileAPIService } from "../fileAPIService";
import { TransitPurchaseOrderAPIService } from "./transitPurchaseOrderAPIService";
import { sanitiseParams } from "src/utils/sanitiser";
import { GetTransitPurchaseOrdersQueryParams, PaginatedTransitPurchaseOrders, TransitPurchaseOrder } from "src/types";
import {
  GetTransitPurchaseOrderByIdQueryParams,
  PatchTransitPurchaseOrderRequestBody,
  PostTransitPurchaseOrdersExportsRequestBody
} from "src/types/api";

class TransitPurchaseOrderService extends BaseService<TransitPurchaseOrderAPIService> {
  private readonly fileAPIService: FileAPIService;

  constructor(apiService: TransitPurchaseOrderAPIService, fileAPIService: FileAPIService) {
    super(apiService);
    this.fileAPIService = fileAPIService;
  }

  @sanitiseParams()
  async getTransitPurchaseOrders(
    queryParams: GetTransitPurchaseOrdersQueryParams
  ): Promise<PaginatedTransitPurchaseOrders> {
    const paginatedTransitPurchaseOrders = await this.apiService.getTransitPurchaseOrders(queryParams);

    return paginatedTransitPurchaseOrders;
  }

  @sanitiseParams()
  async getTransitPurchaseOrderById(
    transitPurchaseOrderId: string,
    queryParams?: GetTransitPurchaseOrderByIdQueryParams
  ): Promise<TransitPurchaseOrder> {
    const transitPurchaseOrder = await this.apiService.getTransitPurchaseOrderById(transitPurchaseOrderId, queryParams);

    return transitPurchaseOrder;
  }

  @sanitiseParams()
  async amendTransitPurchaseOrder(
    transitPurchaseOrderId: string,
    requestBody: PatchTransitPurchaseOrderRequestBody
  ): Promise<TransitPurchaseOrder> {
    const updatedTransitPurchaseOrder = await this.apiService.patchTransitPurchaseOrder(
      transitPurchaseOrderId,
      requestBody
    );

    return updatedTransitPurchaseOrder;
  }

  @sanitiseParams()
  async transitPurchaseOrdersExports(requestBody: PostTransitPurchaseOrdersExportsRequestBody): Promise<File> {
    const { signedUrl, fileName } = await this.apiService.postTransitPurchaseOrdersExports(requestBody);

    const fileBlob = await this.fileAPIService.getFile(signedUrl);

    return new File([fileBlob], fileName, { type: fileBlob.type, lastModified: new Date().getTime() });
  }
}

export { TransitPurchaseOrderService };
